import React from 'react';
import LivePreview from '../livePreview/LiveControls';
import './OnStage.scss';

const OnStage = () => {
    return(
        <section className="preview">
            <LivePreview />
        </section>
    );
}

export default OnStage;